import Login from "pages/auth/login/Login";
import Oauth from "pages/auth/oauth/Oauth";
import OauthLogin from "pages/auth/oauth/OauthLogin";

export const AuthRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <OauthLogin />,
  },
  {
    path: "/oauth",
    element: <Oauth />,
  },
];
